'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'shield';
var width = 512;
var height = 512;
var aliases = [128737,"shield-blank"];
var unicode = 'f132';
var svgPathData = 'M269.4 2.912L457.7 82.79C479.7 92.12 496.2 113.8 496 139.1C495.5 239.2 454.8 420.7 282.4 503.2C265.8 511.1 246.3 511.1 229.6 503.2C57.29 420.7 16.49 239.2 16 139.1C15.87 113.8 32.32 92.12 54.3 82.79L242.7 2.912C246.8 1.007 251.4-.0091 256-.0088C260.7-.0091 265.2 1.007 269.4 2.912L269.4 2.912zM256 49.39L73.04 126.1C67.1 129.5 63.98 134.7 64 139.7C64.45 231.2 102.4 389 250.4 459.9C253.9 461.6 258.1 461.6 261.7 459.9C409.7 389 447.6 231.2 448 139.7C448.1 134.7 444.9 129.5 438.1 126.1L256 49.39z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faShield = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;